import type { Point2d } from ".."
import { isPointInBox } from "./isPointInBox"
import { MICRO, NANO } from "../../constants/SMALL_NUMBERS"
import type { Edge2dComputed } from "../../mesh"
import { edgeToLinearFn, pointsToBox } from "../transmute"

export const isPointOnSegment = (
  p0: Point2d,
  { p1, p2 }: Edge2dComputed,
): boolean => {
  const { x, y } = p0
  const linearFn = edgeToLinearFn({ p1, p2 })
  if (!Number.isFinite(linearFn.slope)) {
    const xIsAligned = Math.abs(x - p1.x) < MICRO
    const yIsInRange = (y >= p1.y && y <= p2.y) || (y <= p1.y && y >= p2.y)

    return xIsAligned && yIsInRange
  }
  if (linearFn.slope === 0) {
    const yIsAligned = Math.abs(linearFn.intercept - y) < NANO
    const xIsInRange = (x >= p1.x && x <= p2.x) || (x <= p1.x && x >= p2.x)

    return xIsInRange && yIsAligned
  }
  const pointIsInRange = isPointInBox(p0, pointsToBox(p1, p2))
  if (!pointIsInRange) {
    return false
  }
  const pointIsOnLine = Math.abs(y - linearFn(x)) < 0.0001

  return pointIsOnLine
}
